
import { CONCEPTS_ACTIONS, CONCEPT_DETAIL_ACTIONS } from "../actions/Concepts";
import { mergeItem } from "utils/common";

export function addConceptCreatives(state, action){
	// TODO: Should we check that the creativeLibraryId matches before adding these?
	const { newAdTypes = []} = action || {};
	const { creatives = []} = action?.payload?.data || {};
	const rpp = state.filterInfo?.rpp;
	let items;

	if(creatives && creatives.length){
		if(newAdTypes.length){
			// newAdTypes are added to the action for adding Creatives to an existing Concept only.
			items = creatives.reduce((prev, creative) => {
				if(newAdTypes.includes(creative?.adType)){
					// We only insert rows for the newly added types.  Other Creatives in the Concept should be untouched.
					return [creative, ...prev];
				}
				return prev;
			}, state.items);
		} else {
			// if newAdTypes is empty or not specified, we're creating a new Concept, so just add every child Creative.
			items = [
				...creatives,
				...state.items,
			];
		}
	} else {
		items = [].concat(state.items);
	}

	const newTotalItems = state.totalItems + (items.length - state.items.length);
	let { totalPages } = state;

	// Check if adding items will increase the total pages
	const maxTotalPages = Math.ceil(newTotalItems / state.filterInfo?.rpp);
	if (maxTotalPages > state.totalPages) {
		totalPages = maxTotalPages;
	}

	return {
		...state,
		isLoaded: true,
		items: items.slice(0, rpp),
		totalPages,
		totalItems: newTotalItems,
	};
}

export function addExistingSocial(state, action){
	let { creatives = []} = action?.payload?.data || {};

	let items = creatives.reduce((prev, creative) => {
		return mergeItem(prev, creative);
	}, [...state.items]);

	return {
		...state,
		isLoaded: true,
		items,
		totalItems: items.length,
	};
}

export function renamingConcept(state, action) {
	return {
		...state,
		modalProps:{
			...state.modalProps,
			disabled:true,
			isLoaded:true,
		},
	};
}

export function renameConceptSuccess(state, action) {
	let  { data } = action?.payload || {}
		, newItems = []
		, i = 0
		, newName = "", conceptId = -1
		;

	if(data?.conceptName){
		newName = data.conceptName;
	}
	if(data?.conceptID){
		conceptId = data.conceptID;
	}

	for(i; i < state.items.length; i++){
		let row = { ...state.items[i] };

		if(row.conceptID === conceptId){
			row.conceptName = newName;
		}

		newItems.push(row);
	}

	return {
		...state,
		items:newItems,
		modalProps:{
			...state.modalProps,
			disabled:true,
			isLoaded:false,
		},
	};
}

export function renameConceptError(state, action) {
	return {
		...state,
		modalProps:{
			...state.modalProps,
			disabled:false,
			isLoaded:false,
			error:true,
		},
	};
}

/**
 * Delete Concept State Updaters
 *********************************/
export function conceptDelete(state, action) {
	return {
		...state,
		error:false,
	};
}

export function successConceptDelete(state, action) {
	let { items } 		= state
		, deleteId		= action?.payload?.original?.conceptId || -1
		, newItems = items.filter(creative => creative.conceptID !== deleteId);

	return {
		...state,
		items:newItems,
		error:false,
	};
}

export function errorConceptDelete(state, action) {
	return {
		...state,
		error:true,
	};
}

export const HANDLERS = {
	[CONCEPTS_ACTIONS.RENAME_CONCEPT_AJAX]:    renamingConcept,
	[CONCEPTS_ACTIONS.RENAME_CONCEPT_SUCCESS]: renameConceptSuccess,
	[CONCEPTS_ACTIONS.RENAME_CONCEPT_ERROR]:   renameConceptError,

	// Delete Concepts
	[CONCEPTS_ACTIONS.DELETE_CONCEPT_AJAX]:    conceptDelete,
	[CONCEPTS_ACTIONS.DELETE_CONCEPT_SUCCESS]: successConceptDelete,
	[CONCEPTS_ACTIONS.DELETE_CONCEPT_ERROR]:   errorConceptDelete,

	// When Concepts are created we need to update the grid
	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT_SUCCESS]:   addConceptCreatives,
	[CONCEPT_DETAIL_ACTIONS.SAVE_ADD_TO_SOCIAL_CONCEPT_SUCCESS]: addExistingSocial,
	[CONCEPT_DETAIL_ACTIONS.SAVE_SOCIAL_CONCEPT_SUCCESS]: addExistingSocial,

	[CONCEPT_DETAIL_ACTIONS.SAVE_NEW_SOCIAL_CONCEPT2_SUCCESS]:   addConceptCreatives,
	[CONCEPT_DETAIL_ACTIONS.ADD_CREATIVE_TO_SOCIAL_CONCEPT2_SUCCESS]: addConceptCreatives,
};
